const account_center = {
    not_enabled: '账户中心未启用。',
    field_not_editable: '字段不可编辑。',
    field_not_enabled: '字段未启用。',
};
export default Object.freeze(account_center);
